export function setIsSavingCareMediation(state, payload) {
  state.isSavingCareMediation = payload;
}
